(ns dre.widgets.publication-type.views
  (:require
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.i18n.views :refer [tr]]
   [dre.widgets.publication-type.events :as-alias events]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn widget-content
  [data]
  (fn []
    [:<>
     (if (not (seq data))
       [no-result true]
       [table-list "publication-type-table" data {:sort-fn :idx}])]))

(defn view
  [id title]
  (let [state @(rf/subscribe [::events/state])
        data @(rf/subscribe [::events/data])
        loading? (= :loading (:state state))]
    [widget-base/view id [title-with-filter title id] [widget-content data]
     {:csv-event [::events/export]
      :export-image? false
      :tooltip (r/as-element [:span
                              [tr "Publication type is determined through proprietary Dr.Evidence machine learning algorithms with curated search strings. For more information and examples of what each publication type contains, please refer to the "]
                              [:a {:target "_blank"
                                   :href "https://8867135.hs-sites.com/search"} [tr "help documentation."]]])}
     {:loading? loading?}]))